import { Collection } from 'modules/core/lib/mobx-rest'

import QuestionGroupConfig from 'modules/reviews/store/models/QuestionGroupConfig'

class QuestionGroupConfigs extends Collection<QuestionGroupConfig> {
  model() {
    return QuestionGroupConfig
  }
}

// get questionGroupConfigs(): QuestionGroupConfig[] {
//   return questionGroupConfigs.filter({
//     surveys_form_id: this.attributes.id,
//   })
// }

export default new QuestionGroupConfigs()
